export default {
  props: {
    showExecutors: {
      type: Boolean,
      default: false,
    },
  },
};
